export default {
  SET_ENTERPRISE_CREW_ID (state, data) {
    state.enterpriseCrewId = data;
  },

  SET_ENTERPRISE_CREW_LABOR_ID(state, data){
    state.enterpriseCrewLaborId = data;
  },

  SET_CREW (state, data) {
    state.crew = data;
  },

  SET_LABORS(state, data){
    state.labors = data;
  },

  RESET_STATE (state) {
    state.enterpriseCrewId = null;
    state.crew = {};
    state.labors = [];
  }
}